import { Link } from "react-router-dom";
import { collections } from "@/data/collections";
import Reveal from "@/components/base/Reveal";

// Editorial portrait imagery for the home page collections strip.
// One tile per collection page (matches the navbar order, minus Featured).
const TILE_IMAGE: Record<string, string> = {
  bedroom:
    "https://readdy.ai/api/search-image?query=A%20simple%20wooden%20farmhouse%20bed%20neatly%20made%20with%20soft%20oatmeal%20linen%20bedding%20a%20folded%20sage%20wool%20throw%20and%20pintuck%20pillow%20shams%20by%20a%20bright%20window%20warm%20natural%20morning%20light%20muted%20cream%20and%20sage%20color%20palette%20editorial%20documentary%20photography%20soft%20shadows%20simple%20clean%20uncluttered%20background%20cozy%20bedroom%20mood&width=1200&height=1500&seq=collection-tile-bedroom-v3&orientation=portrait",
  "wall-art":
    "https://readdy.ai/api/search-image?query=A%20single%20hand%20lettered%20wooden%20sign%20with%20cursive%20black%20script%20leaning%20against%20a%20cream%20plaster%20wall%20warm%20natural%20morning%20light%20from%20a%20side%20window%20a%20small%20sprig%20of%20dried%20eucalyptus%20on%20the%20floor%20muted%20cream%20and%20warm%20terracotta%20color%20palette%20editorial%20documentary%20photography%20soft%20shadows%20simple%20clean%20uncluttered%20background%20farmhouse%20interior%20mood&width=1200&height=1500&seq=collection-tile-wallart-v3&orientation=portrait",
  kitchenware:
    "https://readdy.ai/api/search-image?query=A%20honey%20glazed%20stoneware%20mug%20and%20small%20stack%20of%20handmade%20ceramic%20plates%20on%20a%20worn%20oak%20farmhouse%20kitchen%20counter%20a%20linen%20tea%20towel%20draped%20beside%20them%20warm%20natural%20morning%20light%20from%20a%20kitchen%20window%20muted%20cream%20and%20honey%20color%20palette%20editorial%20documentary%20photography%20soft%20shadows%20simple%20clean%20uncluttered%20background%20cozy%20kitchen%20mood&width=1200&height=1500&seq=collection-tile-kitchen-v3&orientation=portrait",
};

const FALLBACK =
  "https://readdy.ai/api/search-image?query=A%20quiet%20still%20life%20of%20assorted%20handmade%20farmhouse%20home%20goods%20arranged%20on%20a%20worn%20oak%20table%20against%20a%20cream%20plaster%20wall%20warm%20natural%20morning%20light%20muted%20cream%20and%20earthy%20color%20palette%20editorial%20documentary%20photography%20soft%20shadows%20simple%20clean%20uncluttered%20background%20cozy%20interior%20mood&width=1200&height=1500&seq=collection-tile-fallback-v3&orientation=portrait";

export default function Collections() {
  return (
    <section id="collections" className="px-4 md:px-10 lg:px-14 py-20 md:py-28 scroll-mt-20">
      <Reveal from="up" className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-10 md:mb-14">
        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-foreground-600 mb-3">
            Browse
          </p>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight">
            The collections
          </h2>
        </div>
      </Reveal>

      <ul className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {collections.map((c, idx) => {
          return (
            <Reveal
              as="li"
              from="up"
              delay={idx * 90}
              key={c.slug}
            >
              <Link
                to={`/collections/${c.slug}`}
                className="group block cursor-pointer relative overflow-hidden rounded-lg"
              >
                <div className="w-full overflow-hidden bg-background-100 aspect-[4/5]">
                  <img
                    src={TILE_IMAGE[c.slug] ?? FALLBACK}
                    alt={c.categoryName}
                    title={`${c.categoryName} collection — Hearth & Heirloom`}
                    className="w-full h-full object-cover object-top transition-transform duration-[1200ms] ease-out group-hover:scale-[1.06]"
                  />
                </div>
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />
                {/* Label */}
                <div className="absolute inset-x-0 bottom-0 p-4 md:p-6 flex items-end justify-between">
                  <h3 className="font-heading text-background-50 text-lg md:text-2xl leading-tight">
                    {c.categoryName}
                  </h3>
                  <span className="inline-flex items-center justify-center w-9 h-9 md:w-10 md:h-10 rounded-full bg-background-50/90 text-foreground-950 group-hover:bg-background-50 transition-colors">
                    <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" />
                  </span>
                </div>
              </Link>
            </Reveal>
          );
        })}
      </ul>
    </section>
  );
}